import { env } from '@/lib/env';

export interface NavItem {
  label: string;
  href: string;
  /** Accreditation-mandated page (★ in the information architecture). */
  mandated?: boolean;
}

/**
 * Top-level navigation, distilled from the information architecture in the
 * rebuild brief (§7). Extend with nested children as pages are built out.
 */
export const primaryNav: NavItem[] = [
  { label: 'Programmes', href: '/programmes' },
  { label: 'Admissions', href: '/admissions' },
  { label: 'IBAS experience', href: '/experience' },
  { label: 'About', href: '/about' },
  { label: 'Partners', href: '/partners' },
  { label: 'News & events', href: '/news' },
];

/** Footer legal set (must be carried over — brief §6.2; Complaints added on client request). */
export const footerLegalNav: NavItem[] = [
  { label: 'Disclaimer', href: '/legal/disclaimer' },
  { label: 'Privacy Policy', href: '/legal/privacy' },
  { label: 'Cookies', href: '/legal/cookies' },
  { label: 'Complaints', href: '/legal/complaints' },
  { label: 'Equality, Diversity & Inclusion', href: '/legal/edi' },
  { label: 'Terms & Conditions', href: '/legal/terms' },
];

export const site = {
  url: env.VITE_SITE_URL,
  title: 'International Business Academy of Switzerland (IBAS)',
  description: 'Accessible Swiss quality for global career growth.',
  primaryCta: { label: 'Start your application', href: '/apply' },
} as const;
